import { Button, Theme, MarketingCalloutIcon } from '@spoiler-alert/ui-library';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { createUseStyles } from 'react-jss';
import { ACTIVE_STEP } from '../../pages/offer-comparison/active-step-enums';

const DISMISSED_KEY = 'workflowEnforcementDismissed';

const useStyles = createUseStyles({
  portal: {
    position: 'fixed',
    bottom: '2%',
    right: '1%',
    zIndex: 1000,
    animation: '$slide-up 200ms ease-in-out',
  },
  '@keyframes slide-up': {
    from: {
      transform: 'translateY(calc(100% + 2vh))',
    },
    to: {
      transform: 'translateY(0)',
    },
  },
  content: {
    padding: 36,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    boxShadow: '0 7px 17.4px 0 rgba(0, 0, 0, 0.25)',
    border: '2px solid transparent',
    background: `linear-gradient(36deg, rgba(7, 190, 223, 0.05) -1.21%, rgba(242, 218, 81, 0.05) 88.19%, rgba(42, 178, 74, 0.05) 234.16%) padding-box, linear-gradient(white, white) padding-box, ${Theme.iqGradient} border-box`,
    animation: '$iq-ripple 6s linear infinite',
  },
  header: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '28px',
    letterSpacing: -0.34,
  },
  text: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: -0.176,
    marginTop: 8,
    marginBottom: 24,
  },
  image: {
    marginRight: 24,
  },
  row: {
    display: 'flex',
    gap: 12,
  },
  '@keyframes iq-ripple ': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '50% 100%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    },
  },
});

interface WorkflowEnforcementProps {
  setActiveStep: (step: ACTIVE_STEP) => void;
}

export function WorkflowEnforcement({ setActiveStep }: WorkflowEnforcementProps) {
  const classes = useStyles();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISSED_KEY) === 'true');

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  if (dismissed) return null;

  return createPortal(
    <div className={classes.portal}>
      <div className={classes.content}>
        <div className={classes.image}>
          <MarketingCalloutIcon />
        </div>
        <div>
          <h1 className={classes.header}>Have you finished Step 1?</h1>
          <p className={classes.text}>
            For best results, finish awarding suggested <br /> awards in Step 1 before moving to Step 2.
          </p>
          <div className={classes.row}>
            <Button secondary onClick={handleDismiss}>
              I'm done with Step 1
            </Button>
            <Button secondary onClick={() => setActiveStep(ACTIVE_STEP.SUGGESTIONS)}>
              Return to Step 1
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
